export const PUSH_VIEW = 'push view'
export const POP_VIEW = 'pop view'
export const UPDATE_VIEW_TICKER = 'update view ticker'
export const SWITCH_VIEW_FOCUS = 'switch focus view'
export const DISABLE_VIEWS = 'disable views'
